export const PAGE_ROUTE = 'constructionreceipt';
export const PAGE_NAME = 'Construction Receipt';
